import React from 'react';
import {Button, Form, Input, Modal} from 'antd';
import {$saveOrUpdate} from '@/utils/utils';
import {saveOrUpdate} from '../service';

const FormItem = Form.Item;
const formLayout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 13,
  },
};

const EnterpriseAuthForm = (props:any) => {
  const {formValues, updateModalVisible, onSuccess, onCancel} = props;
  const [form] = Form.useForm();

  const _saveOrUpdate = async () => {
    const fieldsValue = await form.validateFields();
    console.log({fieldsValue});
    let params = {...formValues, ...fieldsValue};
    await $saveOrUpdate({
      func: saveOrUpdate,
      params,
      onSuccess: onSuccess,
    });
  };

  const renderContent = () => {
    return (
      <>
        <FormItem name='licenseCode' label='授权码'>
          <Input placeholder='保存后可见' disabled={true}/>
        </FormItem>
      </>
    );
  };

  const renderFooter = () => {
    return (
      <>
        <Button onClick={onCancel}>取消</Button>
        <Button type='primary' onClick={() => _saveOrUpdate()}>
          立即保存
        </Button>
      </>
    );
  };

  return (
    <Modal
      width={640}
      bodyStyle={{
        padding: '32px 40px 48px',
      }}
      destroyOnClose
      maskClosable={false}
      title={'完善企业信息'}
      open={updateModalVisible}
      footer={renderFooter()}
      onCancel={onCancel}
    >
      <Form {...formLayout} form={form} initialValues={formValues}>
        {renderContent()}
      </Form>
    </Modal>
  );
};

export default EnterpriseAuthForm;
